import React, { useEffect, useRef, useState } from "react";
import { FaFilter } from "react-icons/fa";
import { useRole } from "../../../../../Routing/Routing";
import PaginationComponent from "../../pagination";
import { InputPopup } from "../../../CommonComponents/InputPopup";
import { Link } from "react-router-dom";
import OrderPrint from "./OrdersPrint";
import Select from "react-select";
import { AssignTrackingId } from "./AssignTrackingId";
import { SuccessPopUp } from "../../../CommonComponents/SuccessPopUp";
import { LoadingWait } from "../../../CommonComponents/LoadingWait";

function Order() {

    const { userPermissions } = useRole();
    const permission = (url) => userPermissions.includes(url);
    const BASE_URL = process.env.REACT_APP_PP_URL;
    const token = sessionStorage.getItem('tokenKey');

    const [list, setList] = useState([]);
    const [filterList, setFilterList] = useState([...list]);
    const [type, setType] = useState('ALL');
    const [isLoading, setIsLoading] = useState(false);
    const item = async () => {
        setIsLoading(true);
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/order/getOrderList`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`
                }
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setList(getRes.responsePacket);
                setFilterList(getRes.responsePacket);
                setType('ALL');
            }
        } catch (e) {
            console.log(e, 'error in order list api')
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        item();
    }, []);


    const [showPopup, setShowPop] = useState(false);
    const [message, setMessage] = useState();
    const [getId, setGetId] = useState();
    // const [trackId, setTrackId] = useState();

    // this is update order list 
    // const orderStatus = async (orderId, orderStatus) => {
    //     try {
    //         const res = await fetch(`${BASE_URL}/admin/v1/order/updateOrderStatus/${orderId}/${orderStatus}`, {
    //             method: "PUT",
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //             }
    //         });
    //         const getRes = await res.json();
    //         if (getRes.errorCode === 0) {

    //         }
    //     } catch (e) {
    //         console.log(e, 'error in update order list statues');
    //     }
    // };

    // TRACKING ID
    const [cancelReason, setCancelReason] = useState('');
    const trackingId = async (orderId) => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/order/cancelOrder/${orderId}`, {
                method: "POST",
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    cancelReason: cancelReason
                })
            });
            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setShowPop(false);
                item();
                setSelectedItems([]); // Deselect all items
                setSendPrintitems([]);
                setMultiTrackId([]);
            } else {
                setShowErrorPop(true);
                setAction(getRes.message);
                setShowPop(false);
            }
        } catch (e) {
            console.log(e, 'error in tracking id api');
            setSelectedItems([]); // Deselect all items
            setSendPrintitems([]);
            setMultiTrackId([]);
        }
    };

    const handleStatus = (id) => {
        setGetId(id);
        setShowPop(true);
        setMessage('Reason for cancel');
    };

    const handleOk = () => {
        if (getId && cancelReason) {
            trackingId(getId);
        }
    };

    const handleCancle = () => {
        setShowPop(false);
        setGetId('');
        setCancelReason('');
    };

    const timeFormate = (time) => {
        try {
            // Check if the time is valid
            const date = new Date(time);
            if (isNaN(date)) {
                throw new Error("Invalid date");
            }

            const options = {
                day: 'numeric',    // 5
                month: 'numeric',    // Dec
                year: 'numeric',   // 2024
                hour: '2-digit',   // 10
                minute: '2-digit',
                hour12: true
            };

            const formattedDate = new Intl.DateTimeFormat('en-GB', options).format(date);
            return formattedDate;
        } catch (error) {
            console.error("Invalid time value:", error.message);
            return "Invalid Date";
        }
    };

    const [searchInput, setSearchInput] = useState();

    const handleSearch = (e) => {
        const event = e.target.value;
        setSearchInput(event);

        if (event) {
            const res = list.filter((itm) => {
                // const createdDate = new Date(Number(itm.createdAt)).toISOString().split("T")[0];
                return (
                    timeFormate(itm.createdAt).includes(event) ||
                    itm.customerAddressDetail?.firstName?.toLowerCase().includes(event.toLowerCase()) ||
                    itm.customerAddressDetail?.lastName?.toLowerCase().includes(event.toLowerCase()) ||
                    itm.customerDetail?.userCustomerMobile?.toString().toLowerCase().includes(event.toLowerCase()) ||
                    itm.orderId?.toString().toLowerCase()?.includes(event.toLowerCase())
                );
            });
            setFilterList(res);
        } else {
            setFilterList(list);
        }
        setCurrentPage(1);
    };

    // PAGINATION LOGIC
    const [currentPage, setCurrentPage] = useState(1);

    const resultPerPage = [
        { value: 10, label: "10 items per page" },
        { value: 20, label: "20 items per page" },
        { value: 50, label: "50 items per page" },
        { value: 100, label: "100 items per page" },
        { value: 200, label: "200 items per page" },
    ];
    const [lengthOfPage, setLengthOfPage] = useState(() => {
        return JSON.parse(sessionStorage.getItem("ordersPerPage")) || resultPerPage[2]
    });

    useEffect(() => {
        sessionStorage.setItem("ordersPerPage", JSON.stringify(lengthOfPage));
    }, [lengthOfPage]);


    // Pagination logic
    const itemsPerPage = lengthOfPage?.value; // Show 10 items per page
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;

    // FILTER LIST
    const [sortShow, setSortShow] = useState(false);

    // HANDLE OUTSIDE CLICK
    const ref = useRef(null);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (!ref?.current?.contains(event.target)) {
                setSortShow(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
    }, [ref]);

    // SORT METHOD
    const sort = [
        { id: 1, title: "A-Z" },
        { id: 2, title: "Z-A" },
        { id: 3, title: "Latest Added" },
        { id: 4, title: "Oldest Added" },
        { id: 5, title: "Online" },
        { id: 6, title: "Cash on Delivery" },
        { id: 7, title: "High to low price" },
        { id: 8, title: "low to high price" },
    ];

    const [sortBy, setSortBy] = useState();

    const handleSort = async (by) => {
        setSortBy(by);
        if (by === 'A-Z') {
            const sortAz = [...list].sort((a, b) => a.customerDetail?.userCustomerFirstName?.localeCompare(b.title));
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
            setType('ALL');
        } else if (by === "Z-A") {
            const sortAz = [...list].sort((a, b) => b.customerDetail?.userCustomerFirstName?.localeCompare(a.title));
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
            setType('ALL');
        } else if (by === 'Latest Added') {
            const sortAz = [...list].sort((a, b) => new Date(b.orderStatusLogList[0]?.modifiedAt).getTime() - new Date(a.orderStatusLogList[0]?.modifiedAt).getTime());
            setFilterList(sortAz);
            setCurrentPage(1);
            setSearchInput('');
            setSortShow(false);
        } else if (by === 'Oldest Added') {
            const sortAz = [...list].sort((a, b) => new Date(a.orderStatusLogList[0]?.modifiedAt).getTime() - new Date(b.orderStatusLogList[0]?.modifiedAt).getTime());
            setFilterList(sortAz);
            setCurrentPage(1);
            setSearchInput('');
            setSortShow(false);
        } else if (by === 'paid') {
            const sortAz = [...list].filter((itm) => itm.orderStatus === 'PANDING');
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
            setType('PAID');
        } else if (by === 'Unpaid') {
            const sortAz = [...list].filter((itm) => itm.orderStatus !== 'PANDING');
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
            setType("UNPAID");
        } else if (by === 'High to low price') {
            const sortAz = [...list].sort((a, b) => b.orderTotal - a.orderTotal);
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
        } else if (by === 'low to high price') {
            const sortAz = [...list].sort((a, b) => a.orderTotal - b.orderTotal);
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
        } else if (by === 'Online') {
            const sortAz = [...list].filter((itm) => itm.paymentType === "ONLINE");
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
        } else if (by === 'Cash on Delivery') {
            const sortAz = [...list].filter((itm) => itm.paymentType === "COD");
            setFilterList(sortAz);
            setCurrentPage(1);
            setSortShow(false);
            setSearchInput('');
        } else if (by === "Remove Filter") {
            setFilterList(list);
            setSortBy('');
            setSearchInput('');
            setSortShow(false);
        }
    };

    const [showPrintPreview, setShowPrintPreview] = useState(false);
    const [selectedItems, setSelectedItems] = useState([]);
    const [sendPrintItem, setSendPrintitems] = useState([]);
    const [isSelectAll, setIsSelectAll] = useState(false);

    const handleSelectAll = () => {
        const startIndex = (currentPage - 1) * lengthOfPage?.value;
        const endIndex = startIndex + lengthOfPage?.value;
        const currentPageItems = filterList.slice(startIndex, endIndex);

        if (isSelectAll) {
            setSelectedItems([]); // Deselect all items
            setSendPrintitems([]);
            setMultiTrackId([]);
        } else {
            setSelectedItems(currentPageItems.map((order) => order.orderId)); // Select all items
            setSendPrintitems(currentPageItems);
            setMultiTrackId(currentPageItems.map((itm) => ({ orderId: itm.orderId, updateOrderDetails: { orderTrackingId: itm.orderTrackingId ? itm.orderTrackingId : '', courierPartnerId: "" } })));
        }
        setIsSelectAll(!isSelectAll);
    };

    const [multiTrackId, setMultiTrackId] = useState([]);
    const [showMultiInputs, setShowMultiInputs] = useState(false);
    const [showErrorPop, setShowErrorPop] = useState(false);
    const [action, setAction] = useState();

    const updateOrderTarckingIds = async () => {
        try {
            const res = await fetch(`${BASE_URL}/admin/v1/order/updateOrdersTrackingId`, {
                method: "PUT",
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "application/json"
                },
                body: JSON.stringify(multiTrackId)
            });

            const getRes = await res.json();
            if (getRes.errorCode === 0) {
                setShowMultiInputs(false);
                setSelectedItems([]); // Deselect all items
                setSendPrintitems([]);
                setMultiTrackId([]);
                setType("ALL");
                item();
                setShowErrorPop(true);
                setAction('Tracking ID assign successfully');
            } else {
                setShowErrorPop(true);
                setAction(getRes.message);
                setShowMultiInputs(false);
            }
        } catch (e) {
            console.log(e, "error in update tracking ids");
            setShowErrorPop(true);
            setShowMultiInputs(false);
            setAction(e);
        }
    };

    const handleCheckboxChange = (itemId, itm) => {
        setSelectedItems((prevSelected) =>
            prevSelected.includes(itemId)
                ? prevSelected.filter((id) => id !== itemId) // Uncheck if already selected
                : [...prevSelected, itemId] // Add to selected items
        );

        setSendPrintitems((prev) => prev.includes(itm) ? prev.filter((id) => id !== itm)
            : [...prev, itm]
        );

        setMultiTrackId((prev) => {
            const exists = prev.find((item) => item.orderId === itemId);
            if (exists) {
                // If the orderId already exists, remove it (uncheck)
                return prev.filter((item) => item.orderId !== itemId);
            } else {
                // If the orderId doesn't exist, add a new object
                return [...prev, { orderId: itemId, updateOrderDetails: { orderTrackingId: itm.orderTrackingId ? itm.orderTrackingId : '', courierPartnerId: "" } }];
            }
        });
    };

    const removeOrderTrackID = (orderId) => {
        setMultiTrackId((prev) => {
            const exists = prev.find((item) => item.orderId === orderId);
            if (exists) {
                // If the orderId already exists, remove it (uncheck)
                return prev.filter((item) => item.orderId !== orderId);
            }
        });
    };

    const handleSingleTrackId = (itemId, itm) => {
        setMultiTrackId((prev) => {
            const exists = prev.find((item) => item.orderId === itemId);
            if (exists) {
                // If the orderId already exists, remove it (uncheck)
                return prev.filter((item) => item.orderId !== itemId);
            } else {
                // If the orderId doesn't exist, add a new object
                return [...prev, { orderId: itemId, updateOrderDetails: { orderTrackingId: itm.orderTrackingId ? itm.orderTrackingId : '', courierPartnerId: "" } }];
            }
        });
        setShowMultiInputs(true)
    };

    // Ensure "select all" checkbox reflects the state of individual checkboxes
    // useEffect(() => {
    //     setIsSelectAll((selectedItems.length === filterList.length && filterList.length > 0) && (sendPrintItem.length === filterList.length) && (multiTrackId.length === filterList.length));
    // }, [selectedItems, filterList, sendPrintItem, multiTrackId]);

    useEffect(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        const currentPageItems = filterList.slice(startIndex, endIndex);

        const allSelected = currentPageItems.every((item) =>
            selectedItems.includes(item.orderId) &&
            sendPrintItem.find(i => i.orderId === item.orderId) &&
            multiTrackId.find(i => i.orderId === item.orderId)
        );

        setIsSelectAll(allSelected && currentPageItems.length > 0);
    }, [selectedItems, sendPrintItem, multiTrackId, filterList, currentPage]);


    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setEndDate(""); // Reset end date on start change
    };

    useEffect(() => {
        if (startDate && endDate) {
            const filter = list?.filter((itm) => {
                const itemDate = new Date(itm?.createdAt).toISOString().split("T")[0];
                return itemDate >= startDate && itemDate <= endDate;
            })
            return setFilterList(filter);
        }
    }, [startDate, endDate]);

    const handleReset = () => {
        setStartDate("");
        setEndDate("");
        setFilterList(list);
    };

    return (
        <>
            <div className="category">
                <div className="row">
                    <div className="category" style={{ display: "block", }}>
                        <div className="category-nav" >
                            <div className="category-text">
                                <h4>Order List</h4>
                            </div>
                            <div className="category-btn">
                                <Select
                                    defaultValue={resultPerPage[2]}
                                    closeMenuOnSelect={true}
                                    name="colors"
                                    options={resultPerPage}
                                    value={lengthOfPage}
                                    onChange={(e) => { setLengthOfPage(e); setCurrentPage(1) }}
                                    className="basic-multi-select"
                                    classNamePrefix="select"
                                />
                                <Link to="/admin/orderHistory"><button>Order History</button></Link>
                            </div>
                        </div>
                        <hr />
                        <div className="category-filter">
                            <div className="filterr">
                                {
                                    selectedItems.length > 0 ?
                                        <>
                                            <div className="printer-btn-main tittle">
                                                <button className="uni-btn" onClick={() => { setShowPrintPreview(true) }}>Print</button>
                                            </div>
                                            <div className="printer-btn-main tittle">
                                                <button className="uni-btn" onClick={() => { setShowMultiInputs(true) }}>Assign TrackID</button>
                                            </div>
                                        </>
                                        :
                                        <>
                                            <div className="btn-1">
                                                <button style={{ backgroundColor: type === 'ALL' ? "white" : "black", color: type === 'ALL' ? "black" : "white" }} onClick={() => item()}>Live</button>
                                            </div>

                                            <div className="btn-1">
                                                <button onClick={() => setSortShow(!sortShow)}><FaFilter /></button>
                                                {
                                                    sortShow && <div className="sort-list" style={{ width: "338%" }} ref={ref}>
                                                        {
                                                            sort.map((item) => {
                                                                return (
                                                                    <>
                                                                        <div className="list-item" id="sort" onClick={() => handleSort(item.title)}>
                                                                            <div className="outer-c" >
                                                                                <div className="inner-c" style={{ backgroundColor: sortBy === item.title ? "black" : "" }}></div>
                                                                            </div>
                                                                            <label for={item.id}>{item.title}</label>
                                                                        </div>
                                                                    </>
                                                                )
                                                            })
                                                        }
                                                        <div className="list-item" id="sort" onClick={() => handleSort("Remove Filter")}>
                                                            <label for="filter">Remove Filter</label>
                                                        </div>
                                                    </div>
                                                }

                                            </div>
                                        </>
                                }
                            </div>
                            {/* <div className="d-flex" style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "20px", width: "62%", marginRight: "15px" }}>
                                <div className="">
                                    <label htmlFor="st">start Date:</label>
                                    <input type="date" id="st" style={{ fontSize: "12px", padding: "6px" }} />
                                </div>
                                <div className="">
                                    <label htmlFor="en">End Date:</label>
                                    <input type="date" id="en" style={{ fontSize: "12px", padding: "6px" }} />
                                </div>
                            </div> */}
                            <div className="search" style={{ width: "120%" }}>
                                <h4 style={{ fontSize: "13px" }}>Start Date:</h4>
                                <input type="date"
                                    max={new Date().toISOString().split("T")[0]}
                                    value={startDate} onChange={handleStartDateChange} className="input" style={{ marginRight: "10px", width: "20%", fontSize: "12px" }} />

                                <h4 style={{ fontSize: "13px" }}>End Date:</h4>
                                <input type="date"
                                    className="input"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    min={startDate || ""}
                                    disabled={!startDate} style={{ marginRight: "10px", width: "20%", fontSize: "12px" }} />
                                {(startDate || endDate) && <button onClick={handleReset} style={{ fontSize: "12px", backgroundColor: "whitesmoke", padding: "10px", marginRight: "10px" }}>x</button>}
                                <h4 style={{ fontSize: "13px" }}>Search:</h4>
                                <input type="text" placeholder="Search all Orders" value={searchInput} className="input" onChange={(e) => handleSearch(e)} style={{ fontSize: "12px", width: "20%" }} />
                            </div>
                        </div>
                    </div>
                    <div className="order-list-container sticky-container-order ">
                        <div className="order-list-header ">
                            <div className="tittle"><input type="checkbox"
                                checked={isSelectAll}
                                onChange={handleSelectAll}
                            /></div>
                            <div className="tittle">Order Id</div>
                            <div className="tittle">Date</div>
                            <div className="tittle">Customer</div>
                            <div className="tittle">Total</div>
                            <div className="tittle">Payment Status</div>
                            <div className="tittle">Items</div>
                            <div className="tittle">Delivery type</div>
                            <div className="tittle">Tracking Id</div>
                            <div className="tittle">Action</div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="order-list-container">
                    {
                        filterList?.slice(indexOfFirstItem, indexOfLastItem).map((order, index) => (
                            <div key={index} className="order-list-row">

                                <div className="tittle">
                                    <input type="checkbox"
                                        checked={selectedItems.includes(order.orderId) && sendPrintItem.includes(order) && multiTrackId.some((item) => item.orderId === order.orderId)}
                                        onChange={() => handleCheckboxChange(order.orderId, order)}
                                    />
                                </div>

                                <Link to='/admin/orderDetail' state={{ objectId: order.orderId, fromPage: 'Order' }}>
                                    <div className="tittle">{order.orderId}</div>
                                </Link>
                                <div className="tittle">{order?.orderStatus === "ORDER" ? timeFormate(order?.createdAt) : timeFormate(order?.orderAt)}</div>
                                <div className="tittle">
                                    {order.customerAddressDetail?.firstName} {order.customerAddressDetail?.lastName}
                                    <p>({order.customerDetail?.userCustomerIsdCode}{order.customerDetail?.userCustomerMobile})</p>
                                </div>
                                <div className="tittle">{order.orderTotal}</div>
                                <div className="tittle">
                                    <span className={`status ${order.paymentStatus !== 'PENDING' ? 'paid' : 'unpaid'}`}>
                                        {order.paymentStatus}
                                    </span>
                                </div>
                                <div className="tittle">{order.itemDetailList?.reduce((sum, it) => sum + (it.quantity || 0), 0)}</div>
                                <div className="tittle">{order.standardDelivery ? "standard Delivery" : "Express Delivery"}</div>
                                <div className="tittle">{order.orderTrackingId ? order.orderTrackingId : <p style={{ cursor: "pointer" }}>NaN</p>} </div>

                                <div className="btn flex-btns">
                                    {
                                        order.orderTrackingId ?
                                            <button title="Tracking Id Assigned" className="status active-btn" style={{ cursor: "pointer" }} >Assigned</button>
                                            :
                                            (permission('admin/v1/order/updateOrderTrackingId') && (<button onClick={() => handleSingleTrackId(order.orderId, order)} className="status inactive" title="Enter Tracking Id" style={{ cursor: "pointer" }} >Assign Track Id</button>))
                                    }
                                    {permission('admin/v1/order/cancelOrder') && <button className={`status inactive`} onClick={() => handleStatus(order.orderId)}>Cancel Order</button>}
                                </div>
                            </div>
                        ))}
                </div>

                <div className="pagination">
                    <span>Showing {indexOfFirstItem + 1} to {Math.min(indexOfLastItem, filterList?.length)} of {filterList?.length} entries</span>
                    <span className="pagination-buttons">
                        <PaginationComponent currentPage={currentPage} setCurrentPage={setCurrentPage} totalItem={filterList?.length} lengthOfPage={lengthOfPage} />
                    </span>
                </div>
            </div>

            <SuccessPopUp
                action={action}
                FutherMore={"OK"}
                onClose={() => { setShowMultiInputs(false); setShowErrorPop(false) }}
                isOpen={showErrorPop}
            />

            <InputPopup
                isOpen={showPopup}
                onOk={handleOk}
                onCancel={handleCancle}
                ok='ok'
                cancel='cancel'
                message={message}
                inValue={cancelReason}
                inChange={setCancelReason}
            />

            <OrderPrint
                orders={sendPrintItem}
                isOpen={showPrintPreview}
                allData={list}
                onClose={() => setShowPrintPreview(false)}
            />

            <AssignTrackingId
                isOpen={showMultiInputs}
                data={multiTrackId}
                setData={setMultiTrackId}
                removeOrder={removeOrderTrackID}
                onClose={() => { setShowMultiInputs(false); setMultiTrackId([]); setSelectedItems([]); setSendPrintitems([]) }}
                onSubmit={updateOrderTarckingIds}
            />

            <LoadingWait isTrue={isLoading} />

        </>
    )
}
export default Order;